import { forwardRef, InputHTMLAttributes } from "react";
import { Typography } from "components/Typography";
import styled from "styled-components";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  title?: string;
  id?: string; // Add id prop
}

const Wrapper = styled.div`
  margin-bottom: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media (min-width: 800px) {
    margin-bottom: 0rem;
  }
`;
const Input = styled.input`
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  line-height: 1.5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0;
  box-sizing: border-box;
  font-size: 1rem;
`;
const StyledLabel = styled.label`
  font-weight: 500;
`;

export const LabelField = forwardRef<HTMLInputElement, IProps>(
  ({ title, id, ...props }, ref) => {
    const uniqueId =
      id || `text-field-${Math.random().toString(36).substring(2, 9)}`;

    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();

        const form = e.target.form;
        const index = Array.prototype.indexOf.call(form, e.target);
        const nextInput = form.elements[index + 1];

        if (nextInput) {
          nextInput.focus();
        }
      }
    };

    return (
      <Wrapper>
        <StyledLabel className="mobile-item" htmlFor={uniqueId}>
          {title}
        </StyledLabel>
        <Input ref={ref} id={uniqueId} onKeyDown={handleKeyDown} {...props} />
      </Wrapper>
    );
  }
);
